<script setup lang="ts">
import type { DevUser } from "../types/chat";
import GroupPill from "./GroupPill.vue";

const props = defineProps<{
  users: DevUser[];
  selected: string;
}>();

const emit = defineEmits<{ (e: "select", email: string): void }>();
</script>

<template>
  <section class="user-picker" aria-label="dev user picker">
    <span class="user-picker__label">pretend to be</span>
    <ul>
      <li v-for="u in props.users" :key="u.email || 'anon'">
        <button
          class="user-picker__btn"
          :class="{ 'user-picker__btn--active': props.selected === u.email }"
          @click="emit('select', u.email)"
        >
          <span class="user-picker__name">{{ u.label }}</span>
          <span class="user-picker__groups">
            <GroupPill v-for="g in u.expectedGroups" :key="g" :group="g" />
          </span>
        </button>
      </li>
    </ul>
  </section>
</template>

<style scoped>
.user-picker {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2) var(--space-3);
  align-items: center;
}
.user-picker__label {
  color: var(--color-muted);
  font-size: 0.85rem;
}
ul {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
.user-picker__btn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: 0.35rem 0.75rem;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  color: var(--color-ink);
  font-size: 0.85rem;
  transition: border-color 0.12s, background 0.12s;
}
.user-picker__btn:hover {
  border-color: var(--color-accent-dim);
  background: var(--color-surface-alt);
}
.user-picker__btn--active {
  background: var(--color-accent);
  color: var(--color-inverse);
  border-color: var(--color-accent);
}
.user-picker__btn--active:hover {
  background: var(--color-accent-hover);
}
.user-picker__name {
  font-weight: 500;
}
.user-picker__groups {
  display: inline-flex;
  gap: 0.25rem;
}
</style>
